<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" @click="openApplyInvioceDialog">新增</el-button>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button
          v-if="row.issueStatus == '1' && permissionList.issueredBtn"
          icon="el-icon-s-ticket"
          type="text"
          size="small"
          @click="applyForIssueRed(row)"
        >
          冲红
        </el-button>
      </template>
    </avue-crud>
    <InvoiceApplyDialog ref="invoiceApplyDialog" @submit="applyForInvoice" />
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  directInvoicing,
  issueRed,
} from '@/api/v4ward/invoice/invoice';
import { mapGetters } from 'vuex';
import InvoiceApplyDialog from './invoice-apply-dialog';

export default {
  components: {
    InvoiceApplyDialog,
  },
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        labelWidth: 120,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        column: [
          {
            label: 'id',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '抬头类型',
            prop: 'headerType',
            search: true,
            type: 'select',
            dicData: [
              { label: '个人', value: '1' },
              { label: '企业', value: '2' },
            ],
          },
          {
            label: '抬头名称',
            prop: 'name',
          },
          {
            label: '纳税人识别号',
            prop: 'taxNo',
            hide: true,
          },
          {
            label: '地址、电话',
            prop: 'address',
            hide: true,
          },
          {
            label: '开户银行账号',
            prop: 'bankNo',
            hide: true,
          },
          {
            label: '发票金额',
            prop: 'amount',
          },
          {
            label: '发票内容',
            prop: 'content',
          },
          // {
          //   label: '开票方',
          //   prop: 'salerName',
          // },
          {
            label: '通知电话',
            prop: 'phone',
            search: true,
          },
          {
            label: '通知邮箱',
            prop: 'mailbox',
            search: true,
          },
          {
            label: '开票状态',
            prop: 'issueStatus',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=invoice_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '创建时间',
            prop: 'createTime',
          },
          {
            label: '发票pdf下载地址',
            prop: 'pdfUrl',
            hide: true,
          },
          {
            label: '发票号码',
            prop: 'invoiceNo',
            search: true,
            hide: true,
          },
          {
            label: '发票代码',
            prop: 'invoiceCode',
            hide: true,
          },

          {
            label: '备注',
            prop: 'remark',
            span: 24,
            type: 'textarea',
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.invoicechannel_add, false),
        viewBtn: this.vaildData(this.permission.invoicechannel_view, false),
        delBtn: this.vaildData(this.permission.invoicechannel_delete, false),
        editBtn: this.vaildData(this.permission.invoicechannel_edit, false),
        issueredBtn: this.vaildData(this.permission.invoicechannel_issuered, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    //打开申请发票弹窗
    openApplyInvioceDialog() {
      this.$refs.invoiceApplyDialog.openDialog();
    },
    //申请发票
    applyForInvoice(data, cb) {
      let loading = this.$loading();
      directInvoicing(data)
        .then((res) => {
          loading.close();
          this.$message({
            message: res.msg,
            type: res.success ? 'success' : 'error',
          });
          cb();
          this.onLoad();
        })
        .catch((res) => {
          loading.close();
          console.log('res==>', res);
          cb();
        });
    },
    //冲红
    applyForIssueRed(row) {
      this.$confirm('是否提交 冲红发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          return issueRed({ id: row.id });
        })
        .then((res) => {
          this.loading = false
          this.$message.success(res.msg);
        })
        .catch((err) => {
          this.loading = false
          if (err == 'cancel') {
            this.$message.info('已取消');
          }
        });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
</style>
